export enum MainLanguagesEnum {
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
}
